module.exports = __webpack_public_path__ + "static/media/hollow_bar_tall.fcf92b5e.svg";